export default "__VITE_ASSET__CeQyfhAQ__"